import React, { useEffect, useState } from 'react';
import { URL } from '../api';
import axiosInstance from '../request';
import getPrivilegeList from "./PrivilegeList";

const LoanList = () => {
  const [loans, setLoans] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [disbursedDate, setDisbursedDate] = useState('');
  const [status, setStatus] = useState('');

const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage] = useState(10);
const currentRows = loans;
const [hasNextPage, setHasNextPage] = useState(false); 
const privilegeList = getPrivilegeList();

const companyCode = localStorage.getItem("companyCode");
const branchCode = localStorage.getItem("branch_code");


const fetchLoans = async (page = 1) => {
  try {
    const params = new URLSearchParams();

    // company / branch filter
    if (companyCode) params.append('companyCode', companyCode);
    if (companyCode && branchCode) params.append('branchCode', branchCode);

    if (filterType === 'customerId') params.append('customerId', filterValue);
    if (filterType === 'loanId') params.append('loanId', filterValue);
    if (disbursedDate) params.append('disbursedDate', disbursedDate);
    if (status) params.append('status', status);

    params.append('page', page - 1);
    params.append('size', rowsPerPage);

    const res = await axiosInstance.get(
      `${URL.LOAN_LIST}?${params.toString()}`
    );

    const data = Array.isArray(res.data) ? res.data : [];

    setLoans(data);
    setCurrentPage(page);

    // 🔑 KEY LINE
    setHasNextPage(data.length === rowsPerPage);

  } catch (error) {
    console.error('Error fetching loans:', error);
    setLoans([]);
    setHasNextPage(false);
  }
};



  useEffect(() => {
    fetchLoans();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      fetchLoans();
    }
  };


  return (
    <div className="container">
      <h3 className="mb-4">All Loan List</h3>

      {/* Filter Section */}
      <div className="card mb-4 p-3">
        <div className="row gx-2 gy-2 align-items-end">
          <div className="col-auto">
            <label className="form-label">Filter Type</label>
            <select
              className="form-select form-select-sm"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              onKeyDown={(e) => e.preventDefault()}
            >
              <option value="">Select</option>
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
            </select>
          </div>

          {filterType && (
            <div className="col-auto">
              <label className="form-label">
                {filterType === 'customerId' ? 'Customer ID' : 'Loan ID'}
              </label>
              <input
                type="number"
                className="form-control form-control-sm"
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
          )}

          <div className="col-auto">
            <label className="form-label">Disbursed Date</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={disbursedDate}
              onChange={(e) => setDisbursedDate(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="col-auto">
            <label className="form-label">Status</label>
            <select
              className="form-select form-select-sm"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              onKeyDown={handleKeyDown}
            >
              <option value="">Select</option>
              <option value="1">Active</option>
              <option value="2">Pending</option>
              <option value="3">Closed</option>
              <option value="4">Cancelled</option>
              <option value="5">Disburse</option>
            </select>
          </div>

          <div className="col-auto">
            <button className="btn btn-sm btn-primary mt-1" onClick={() => fetchLoans(1)}>
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
         <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>Lid</th>
              <th>Cid</th>
              <th>Customer Name</th>
              <th>Amount</th>
              <th>Tenure</th>
              <th>Fintech Name</th>
              <th>Roi</th>
              <th>Roi Type</th>
              <th>Disbursed Date</th>
              <th>Status</th>
              {privilegeList.loanDetailsView && (
                <th>Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(currentRows) && currentRows.length > 0 ? (
              currentRows.map((loan, index) => (
                <tr key={loan.loan_id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{loan.loan_id}</td>
                  <td>{loan.customer_id}</td>
                  <td>{loan.borrower_name || '-'}</td>
                  <td>₹{loan.loan_amount.toLocaleString()}</td>
                  <td>{loan.tenure} days</td>
                  <td>{loan.fintech_name}</td>
                  <td>{loan.roi}%</td>
                  <td>{loan.roi_type_name}</td>
                  <td>{loan.disbursed_date ? loan.disbursed_date.slice(0, 10) : '-'}</td>
                  <td>
                    <span
                      className={`badge rounded-pill ${loan.status_name === 'Active'
                          ? 'bg-success'
                          : loan.status_name === 'Pending'
                            ? 'bg-warning text-dark'
                            : 'bg-secondary'
                        }`}
                    >
                      {loan.status_name}
                    </span>
                  </td>
                  {privilegeList.loanDetailsView && (
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          (window.location.href = `#/LoanView?loanId=${loan.loan_id}`)
                        }
                      >
                        View
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center text-muted">
                  No loan records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

<div className="d-flex justify-content-center mt-3">
  <div className="d-flex align-items-center" style={{ gap: "8px" }}>

    {/* Prev */}
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => fetchLoans(currentPage - 1)}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    {/* Page indicator */}
    <span className="px-2">
      Page {currentPage}
    </span>

        {/* Dots */}
    {hasNextPage && (
      <span className="text-muted">.....</span>
    )}

    {/* Next */}
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => fetchLoans(currentPage + 1)}
      disabled={!hasNextPage}
    >
      Next
    </button>

  </div>
</div>
    </div>
  );
};

export default LoanList;
